import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { API_BASE_URL } from '@app/core/tokens/api-base-url.token';
import { SnackbarService } from '@app/core/services/snackbar.service';
import {
  PartnerSalesAnalytics,
  PartnerSalesAnalyticsFilters,
} from '@app/core/models/management/partner-sales-analytics.model';

/** Сумма и количество активированных B2B-сертификатов с разбивкой по сетям */
@Injectable({
  providedIn: 'root',
})
export class PartnerSalesAnalyticsService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);
  private readonly snackbarService = inject(SnackbarService);
  private readonly translate = inject(TranslateService);

  readonly isLoading = signal(false);

  getPartnerSales(filters: PartnerSalesAnalyticsFilters): Observable<PartnerSalesAnalytics | null> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(filters)) {
      if (value === null || value === undefined || value === '') continue;
      if ((key === 'from' || key === 'to') && filters.period !== 'CUSTOM') continue;
      params = params.set(key, String(value));
    }

    this.isLoading.set(true);
    return this.http
      .get<PartnerSalesAnalytics>(`${this.apiBaseUrl}/b2b/admin/analytics/partner-sales`, { params })
      .pipe(
        catchError(error => {
          console.error('Ошибка при загрузке аналитики продаж:', error);
          this.translate.get('Не удалось загрузить аналитику продаж').subscribe(msg => {
            this.snackbarService.error(msg);
          });
          return of(null);
        }),
        finalize(() => this.isLoading.set(false))
      );
  }
}
